import { Text } from '@updater/ui-uds';

/* Created as component for use elsewhere */
export const Disclaimer: React.FC = () => {
  return (
    <Text as="p" variant="m" mb="m">
      A welcome kit with coupons from USPS will arrive at your new address.
      Please be on the lookout as this will also contain your confirmation
      number which is needed to cancel or make changes. Updater does not have
      access to this confirmation number.
    </Text>
  );
};
